<template>
  <section v-if="tickets.length" class="stuck" data-test="stuck-tickets">
    <header class="stuck-head">
      <h3 class="stuck-title">Stuck tickets</h3>
      <span class="stuck-sub">{{ tickets.length }} ticket(s) idle &gt; 3 days</span>
    </header>
    <ul class="stuck-list">
      <li v-for="t in tickets" :key="t.key" class="stuck-row" :data-test="`stuck-${t.key}`">
        <a class="key mono" :href="buildIssueUrl(t.key)" target="_blank" rel="noopener noreferrer">{{ t.key }}</a>
        <span class="status">{{ t.status }}</span>
        <a class="summary" :href="buildIssueUrl(t.key)" target="_blank" rel="noopener noreferrer" :title="t.summary">{{ t.summary }}</a>
        <span class="age" title="Days idle inside the sprint window">
          <strong>{{ t.days_idle_in_sprint }}</strong>d
        </span>
        <span v-if="t.story_points != null" class="sp mono">{{ t.story_points }} SP</span>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { StuckTicket } from "@/api/types";
import { buildIssueUrl } from "@/lib/jiraJql";

const props = defineProps<{ stuckTickets?: StuckTicket[] }>();
const tickets = computed(() => props.stuckTickets ?? []);
</script>

<style scoped>
.stuck {
  border: 1px solid #fde68a;
  background: #fffbeb;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex; flex-direction: column; gap: 8px;
}
.stuck-head { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.stuck-title { font-size: 14px; font-weight: 600; margin: 0; color: #92400e; }
.stuck-sub { font-size: 11px; color: #92400e; text-transform: uppercase; letter-spacing: 0.04em; }
.stuck-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 4px; }
.stuck-row {
  display: grid;
  grid-template-columns: 90px 130px 1fr auto auto;
  gap: 10px; align-items: center;
  font-size: 12px; padding: 4px 0;
  border-bottom: 1px dashed #fde68a;
}
.stuck-row:last-child { border-bottom: 0; }
.key { font-weight: 600; color: #92400e; text-decoration: none; }
.key:hover { text-decoration: underline; }
.status { color: #6b7280; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.summary { color: var(--text-color, #111827); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-decoration: none; }
.summary:hover { text-decoration: underline; }
.age { color: #b45309; }
.sp { color: var(--text-muted, #6b7280); font-size: 11px; }
.mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
</style>
